import {
  TeamOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import { twMerge } from "tailwind-merge";
import Card from "@/shared/data-display/card";
import { Statistic } from "@/shared/data-display/statistic";
import { usePalette } from "@/shared/theme";
import { useDocumentsTranslations } from "@/modules/documents/shared/utils/use-documents-translations";
import { useParticipantsSummary } from "../model/use-participants-summary";

export function CompanyDocumentParticipantsSummary({ id }: { id: string }) {
  const t = useDocumentsTranslations();
  const palette = usePalette();
  const { total, read, unread, readPercent, unreadPercent } =
    useParticipantsSummary({ id });

  const percentSuffix = (value: number) => (
    <span className="text-sm text-[--palette-text-secondary]">{value}%</span>
  );

  const statisticClassName = twMerge(
    "[&_.ant-statistic-content]:flex [&_.ant-statistic-content]:items-center",
    "[&_.ant-statistic-content-suffix]:!ml-auto",
  );

  return (
    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
      <Card>
        <Statistic
          className={statisticClassName}
          title={t("Total participants")}
          value={total}
          prefix={<TeamOutlined />}
        />
      </Card>
      <Card>
        <Statistic
          className={statisticClassName}
          title={t("Reviewed participants")}
          value={read}
          prefix={<CheckCircleOutlined />}
          suffix={percentSuffix(readPercent)}
          valueStyle={{ color: palette.success[5] }}
        />
      </Card>
      <Card>
        <Statistic
          className={statisticClassName}
          title={t("Awaiting actions")}
          value={unread}
          prefix={<ClockCircleOutlined />}
          suffix={percentSuffix(unreadPercent)}
          valueStyle={{ color: palette.warning[5] }}
        />
      </Card>
    </div>
  );
}
